import React, { useState, useEffect } from "react";
import { useAppContext } from "../../App.jsx";
import { Tag } from "../../components/utilityComps.jsx";
import { twMerge } from "tailwind-merge";
import { PrizeboxTab, PrizeboxSidePanel } from "./PrizeboxTab.jsx";
import { BigboxTab, BigboxSidePanel } from "./BigboxTab.jsx";
import { GlassCard, BackgroundOrbs } from "./dependencies.jsx";

export const PageContext = React.createContext({});
export const usePageContext = () => React.useContext(PageContext);

export const PrizeboxPage = () => {
  const appcon = useAppContext();
  const { psearch, upd_psearch } = appcon;
  const [tab, set_tab] = useState(psearch.tab ?? "prizebox"); // prizebox, bigbox

  useEffect(() => {
    upd_psearch({ tab });
  }, [tab]);

  const pagecon = { tab, set_tab };

  return (
    <PageContext.Provider value={pagecon}>
      <div className="h-page relative">
        {/* Animated Background Orbs */}
        <BackgroundOrbs />

        {/*         <div className="w-[8rem] aspect-square bg-red-500 spin-anim "></div> */}

        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="h-8 md:h-12"></div>

          {/* Modern Glass Tab Navigation */}
          <div className="flex justify-center items-center mb-12 md:mb-16">
            <GlassCard className="flex p-1.5 rounded-full space-x-1 bg-r3dark/20 border-r3lig/30">
              <button
                onClick={() => set_tab("prizebox")}
                className={twMerge(
                  "px-8 py-3 rounded-full font-digi font-semibold transition-all duration-300 relative overflow-hidden group",
                  tab === "prizebox"
                    ? "bg-gradient-to-r from-r3reg to-r3dark text-white shadow-xl shadow-r3reg/60 transform scale-105 hover:shadow-2xl hover:shadow-r3reg/80"
                    : "text-gray-300 hover:text-white hover:bg-gradient-to-r hover:from-r3lig/20 hover:to-r3reg/20 hover:scale-105 hover:shadow-lg hover:shadow-r3lig/40 active:scale-95",
                )}
              >
                <span className="relative z-10">Prize Box</span>
                {tab === "prizebox" && (
                  <div className="absolute inset-0 bg-gradient-to-r from-r3lig/30 to-r3reg/30 animate-glow-pulse rounded-full" />
                )}
                {/* Hover glow effect for inactive state */}
                {tab !== "prizebox" && (
                  <div className="absolute inset-0 bg-gradient-to-r from-r3lig/20 to-r3reg/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                )}
              </button>

              <button
                onClick={() => set_tab("bigbox")}
                className={twMerge(
                  "px-8 py-3 rounded-full font-digi font-semibold transition-all duration-300 relative overflow-hidden group",
                  tab === "bigbox"
                    ? "bg-gradient-to-r from-r3reg to-r3dark text-white shadow-xl shadow-r3reg/60 transform scale-105 hover:shadow-2xl hover:shadow-r3reg/80"
                    : "text-gray-300 hover:text-white hover:bg-gradient-to-r hover:from-r3lig/20 hover:to-r3reg/20 hover:scale-105 hover:shadow-lg hover:shadow-r3lig/40 active:scale-95",
                )}
              >
                <span className="relative z-10">Big Box</span>
                {tab === "bigbox" && (
                  <div className="absolute inset-0 bg-gradient-to-r from-r3lig/30 to-r3reg/30 animate-glow-pulse rounded-full" />
                )}
                {/* Hover glow effect for inactive state */}
                {tab !== "bigbox" && (
                  <div className="absolute inset-0 bg-gradient-to-r from-r3lig/20 to-r3reg/20 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                )}
              </button>
            </GlassCard>
          </div>

          {/* Tab Content with Smooth Transitions */}
          <div className="relative overflow-hidden min-h-[600px]">
            <div
              className={twMerge(
                "transition-all duration-500 ease-in-out transform w-full",
                tab === "prizebox"
                  ? "translate-x-0 opacity-100"
                  : "-translate-x-full opacity-0 absolute top-0 left-0",
              )}
            >
              <div className="grid grid-cols-1 xl:grid-cols-5 gap-8 lg:gap-12">
                <div className="xl:col-span-3">
                  <PrizeboxTab />
                </div>
                <div className="xl:col-span-2">
                  <PrizeboxSidePanel />
                </div>
              </div>
            </div>

            <div
              className={twMerge(
                "transition-all duration-500 ease-in-out transform w-full",
                tab === "bigbox"
                  ? "translate-x-0 opacity-100"
                  : "translate-x-full opacity-0 absolute top-0 left-0",
              )}
            >
              <div className="grid grid-cols-1 xl:grid-cols-5 gap-8 lg:gap-12">
                <div className="xl:col-span-3">
                  <BigboxTab />
                </div>
                <div className="xl:col-span-2">
                  <BigboxSidePanel />
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Spacing */}
          <div className="h-16 md:h-24"></div>
        </div>
      </div>
    </PageContext.Provider>
  );
};
